import React from "react";
import { ControlLabel, FormControl } from "react-bootstrap";
import Button from "../../components/SurveyButton";
import SurveyCheckbox from "../../components/SurveyCheckbox";
import SurveyField from "../../components/SurveyField";
import { moveItem } from "../../domain/survey.formatters";
import { newOption } from "../../domain/survey.factories";
import { snakeValue } from "../../domain/survey.mappers";

const ChoiceQuestionFields = ({ question, errors, readOnly, update }) => {
  const optionErrors = errors.optionErrors || {};
  const updateOption = (optionIndex, label) => {
    const options = (question.options || []).slice();
    options[optionIndex] = { ...options[optionIndex], label };
    update("options", options);
  };
  return (
    <div className="survey-engine-options">
      <div className="survey-engine-subheading">
        <strong>Answer options</strong>
        {!readOnly && <Button bsSize="small" icon="fa-plus" onClick={() => update("options", [...(question.options || []), newOption(question.options || [])])}>Add option</Button>}
      </div>
      {errors.options && <div className="survey-engine-validation-banner">{errors.options}</div>}
      {(question.options || []).map((option, optionIndex) => {
        const currentErrors = optionErrors[optionIndex] || {};
        return (
          <div className="survey-engine-option-row survey-engine-option-row-simple" key={option.id}>
            <span className="survey-engine-option-number">{optionIndex + 1}</span>
            <SurveyField label="Option text" required error={currentErrors.label || currentErrors.id}>
              <FormControl placeholder="Enter an answer option" value={option.label || ""} disabled={readOnly} onChange={(event) => updateOption(optionIndex, event.target.value)} />
              <small className="survey-engine-derived-value">Value: {snakeValue(option.label) || "—"}</small>
            </SurveyField>
            {!readOnly && (
              <div className="survey-engine-option-actions">
                <Button bsSize="small" icon="fa-arrow-up" aria-label="Move option up" title="Move option up" disabled={optionIndex === 0} onClick={() => update("options", moveItem(question.options, optionIndex, optionIndex - 1))} />
                <Button bsSize="small" icon="fa-arrow-down" aria-label="Move option down" title="Move option down" disabled={optionIndex === question.options.length - 1} onClick={() => update("options", moveItem(question.options, optionIndex, optionIndex + 1))} />
                <Button bsSize="small" bsStyle="danger" icon="fa-trash" aria-label="Remove option" title="Remove option" onClick={() => update("options", question.options.filter((item) => item.id !== option.id))} />
              </div>
            )}
          </div>
        );
      })}
      {question.type === "single_choice" && (
        <div className="survey-engine-option-row survey-engine-other-option-row">
          <span className="survey-engine-option-number">{(question.options || []).length + 1}</span>
          <div className="survey-engine-other-option-content">
            <div className="survey-engine-other-choice">
              <ControlLabel>Custom response option</ControlLabel>
              <SurveyCheckbox id={`survey-other-${question.id}`} label="Allow a customer-entered response" checked={question.allowOther} disabled={readOnly} onChange={(checked) => update("allowOther", checked)} />
            </div>
            {question.allowOther && (
              <>
                <SurveyField label="Label" required error={errors.otherLabel}>
                  <FormControl placeholder="e.g. Other" value={question.otherLabel || ""} disabled={readOnly} onChange={(event) => update("otherLabel", event.target.value)} />
                  <small className="survey-engine-derived-value">Value: other</small>
                </SurveyField>
                <SurveyField label="Textbox placeholder" required error={errors.otherPlaceholder}>
                  <FormControl placeholder="e.g. Please specify" value={question.otherPlaceholder || ""} disabled={readOnly} onChange={(event) => update("otherPlaceholder", event.target.value)} />
                </SurveyField>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ChoiceQuestionFields;
